import React from "react";
import { Button as PReactButton } from "primereact/button";

/**
 * 
 * @param {{className:string,disabled:boolean,label:string,onClick:function,type:string}} props 
 * @returns 
 */

const Button = ({ className, disabled, label, onClick, type }) => {
  return (
    <PReactButton
      className={className}
      type={type}
      onClick={onClick}
      disabled={disabled}
      label={label}
    />
  );
};

export default Button;
